import { css } from '@emotion/core';
import { Heading, PrimaryButton, RadioField, useForm } from '@weave/design-system';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { LocationTypes } from 'redux/actions/location';
import { LOCATION } from '../../../constants/paths';

type LocationType = 'dev' | 'demo' | 'newcustomer' | 'truelark_customer';

const LocationTypeOptions: { label: string; value: LocationType }[] = [
  { label: 'A dev location and phone tenant', value: 'dev' },
  {
    label: 'A demo location and phone tenant (for sales, onboarding, etc.)',
    value: 'demo',
  },
  {
    label: 'A new customer and phone tenant (not recommended - do it through Salesforce)',
    value: 'newcustomer',
  },
  {
    label: 'A new external customer and phone tenant (only for Truelark customers)',
    value: 'truelark_customer',
  },
];

const LocationTypePathMap: Record<
  LocationType,
  { pathname: string; state: { state?: { Type?: LocationTypes } } }
> = {
  dev: { pathname: LOCATION.dev, state: { state: { Type: LocationTypes.Dev } } },
  demo: { pathname: LOCATION.demo, state: { state: { Type: LocationTypes.Demo } } },
  newcustomer: {
    pathname: LOCATION.newcustomer,
    state: { state: { Type: LocationTypes.Regular } },
  },
  truelark_customer: {
    pathname: LOCATION.truelarkCustomer,
    state: { state: { Type: LocationTypes.External } },
  },
};

export const LocationCreateWizard: FC = (props) => {
  const history = useHistory();
  const { getFieldProps, formProps } = useForm({
    fields: {
      locationType: {
        value: 'dev',
        type: 'radio',
      },
    },
    onSubmit: (values) => {
      history.push(LocationTypePathMap[values.locationType as LocationType]);
    },
  });

  return (
    <form css={styles.form} {...formProps}>
      <Heading level={3}>What kind of location would you like to create: </Heading>
      <RadioField {...getFieldProps('locationType')}>
        {LocationTypeOptions.map((option) => (
          <RadioField.Radio value={option.value} key={option.value}>
            {option.label}
          </RadioField.Radio>
        ))}
      </RadioField>
      <div css={{ width: 150 }}>
        <PrimaryButton type="submit">Next</PrimaryButton>
      </div>
    </form>
  );
};

const styles = {
  form: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px;
    margin: 30px;
    overflow: auto;
  `,
};
